import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useRef, useState } from 'react';
import { JoveButton, JoveTextFieldControlled } from '@jove-frontend/mui';
import { Alert, Box, Typography } from '@mui/material';
import { apiJoveSendLoginTwoFactorCode, apiJoveVerifyLoginTwoFactorCode } from 'libs/uikit/src/api/combineApi';
import { REQUEST_SUCCESS_CODE } from 'libs/uikit/src/constants';
import { useFormContext } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var TwoFactorAuthenticationForm = function TwoFactorAuthenticationForm(props) {
  var onVerified = props.onVerified,
      onSkip = props.onSkip,
      onBackToLogin = props.onBackToLogin;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      getValues = _useFormContext.getValues,
      handleSubmit = _useFormContext.handleSubmit;

  var _useState = useState(false),
      sending = _useState[0],
      setSending = _useState[1];

  var _useState2 = useState(false),
      verifying = _useState2[0],
      setVerifying = _useState2[1];

  var _useState3 = useState(false),
      codeSent = _useState3[0],
      setCodeSent = _useState3[1];

  var _useState4 = useState(''),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var initialSendTriggeredRef = useRef(false);
  /**
   * request
   */

  var requestSendTwoFactorCode = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$apiJoveSendLog, _yield$apiJoveSendLog2, res, err;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSending(true);
              setErrorMessage('');
              _context.next = 4;
              return apiJoveSendLoginTwoFactorCode({
                email: getValues('email')
              });

            case 4:
              _yield$apiJoveSendLog = _context.sent;
              _yield$apiJoveSendLog2 = _slicedToArray(_yield$apiJoveSendLog, 2);
              res = _yield$apiJoveSendLog2[0];
              err = _yield$apiJoveSendLog2[1];
              setSending(false);

              if (!((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE)) {
                _context.next = 12;
                break;
              }

              setCodeSent(true);
              return _context.abrupt("return");

            case 12:
              setErrorMessage((err === null || err === void 0 ? void 0 : err.message) || 'The verification code could not be sent. Please try again or continue without verification.');

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestSendTwoFactorCode() {
      return _ref.apply(this, arguments);
    };
  }();

  var requestVerifyTwoFactorCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$apiJoveVerifyL, _yield$apiJoveVerifyL2, res, err;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setVerifying(true);
              setErrorMessage('');
              _context2.next = 4;
              return apiJoveVerifyLoginTwoFactorCode({
                email: getValues('email'),
                code: getValues('twoFactorCode')
              });

            case 4:
              _yield$apiJoveVerifyL = _context2.sent;
              _yield$apiJoveVerifyL2 = _slicedToArray(_yield$apiJoveVerifyL, 2);
              res = _yield$apiJoveVerifyL2[0];
              err = _yield$apiJoveVerifyL2[1];
              setVerifying(false);

              if (!((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE)) {
                _context2.next = 12;
                break;
              }

              onVerified === null || onVerified === void 0 ? void 0 : onVerified();
              return _context2.abrupt("return");

            case 12:
              setErrorMessage((err === null || err === void 0 ? void 0 : err.message) || 'The verification code could not be verified. Please try again or continue without verification.');

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function requestVerifyTwoFactorCode() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * effects
   */


  useEffect(function () {
    if (initialSendTriggeredRef.current) return;
    initialSendTriggeredRef.current = true;
    requestSendTwoFactorCode();
  }, []);
  /**
   * methods
   */

  var verifyAction = function verifyAction(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    handleSubmit(requestVerifyTwoFactorCode)();
  };

  var resendCodeAction = function resendCodeAction() {
    if (sending || verifying) return;
    requestSendTwoFactorCode();
  };

  var skipAction = function skipAction() {
    onSkip === null || onSkip === void 0 ? void 0 : onSkip();
  };

  var backToLoginAction = function backToLoginAction() {
    onBackToLogin === null || onBackToLogin === void 0 ? void 0 : onBackToLogin();
  };

  var validateCode = function validateCode(value) {
    return /^\d{6}$/.test(value || '') || 'Enter the 6-digit verification code.';
  };

  return /*#__PURE__*/_jsxs(Box, {
    component: "form",
    noValidate: true,
    className: "flex w-full flex-col space-y-6",
    onSubmit: verifyAction,
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-2",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "h1",
        className: "text-3xl font-black text-[#202020] md:text-4xl",
        children: "Two-factor authentication"
      }), /*#__PURE__*/_jsxs(Typography, {
        className: "text-sm leading-6 text-gray-600",
        children: ["Enter the 6-digit verification code sent to ", /*#__PURE__*/_jsx("strong", {
          children: getValues('email')
        }), "."]
      })]
    }), /*#__PURE__*/_jsx(JoveTextFieldControlled, {
      name: "twoFactorCode",
      control: control,
      rules: {
        validate: validateCode
      },
      autoFocus: true,
      autoComplete: "one-time-code",
      label: "Verification code",
      placeholder: "Enter 6-digit code",
      inputProps: {
        inputMode: 'numeric',
        maxLength: 6
      }
    }), /*#__PURE__*/_jsx(Alert, {
      severity: "info",
      children: "Use any 6-digit code while the verification service is being connected."
    }), sending && /*#__PURE__*/_jsx(Alert, {
      severity: "info",
      children: "Sending a new verification code..."
    }), codeSent && !sending && /*#__PURE__*/_jsx(Alert, {
      severity: "success",
      children: "A verification code has been sent."
    }), errorMessage && /*#__PURE__*/_jsx(Alert, {
      severity: "error",
      children: errorMessage
    }), /*#__PURE__*/_jsx(JoveButton, {
      type: "submit",
      variant: "contained",
      color: "primary",
      size: "large",
      loading: verifying,
      disabled: sending,
      className: "w-full",
      children: "Verify and continue"
    }), /*#__PURE__*/_jsx(JoveButton, {
      type: "button",
      variant: "text",
      color: "primary",
      loading: sending,
      disabled: verifying,
      onClick: resendCodeAction,
      children: "Resend verification code"
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col items-center space-y-4 border-t border-gray-200 pt-6",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-center text-sm leading-6 text-gray-500",
        children: "Do not want to complete verification now? Continue with the standard login flow."
      }), /*#__PURE__*/_jsx(JoveButton, {
        type: "button",
        variant: "outlined",
        color: "primary",
        size: "large",
        disabled: verifying,
        className: "w-full",
        onClick: skipAction,
        children: "Continue without verification"
      }), /*#__PURE__*/_jsx(Typography, {
        component: "button",
        type: "button",
        className: "cursor-pointer text-sm font-semibold text-[#CD0D47] hover:underline",
        onClick: backToLoginAction,
        children: "Back to log in"
      })]
    })]
  });
};

export default TwoFactorAuthenticationForm;